import {
  ArrayElement,
  GettingStartedContent,
  LayoutContent,
  getLocalizedContent,
} from "@onzeit/shared";
import { Link } from "@remix-run/react";
import { PropsWithoutRef } from "react";

export const GettingStarted = ({
  locale,
  content,
}: PropsWithoutRef<{
  content: ArrayElement<typeof GettingStartedContent>;
  locale: string;
}>) => {
  const layoutContent = getLocalizedContent(locale!, LayoutContent);

  return (
    <div className="flex flex-col items-center gap-y-4">
      <div className="mb-4 flex max-w-4xl flex-col gap-y-4 xl:mb-10">
        <h1 className="text-3xl font-bold xl:text-4xl">
          {content.data.Heading}
        </h1>
        <p className="text-lg xl:text-xl">{content.data.Subheading}</p>
      </div>
      <div className="flex flex-col gap-y-8 xl:gap-y-14">
        {content.data.Items?.map((item, index) => (
          <Item
            key={index}
            number={index + 1}
            title={item.text}
            description={item.description}
          />
        ))}
        <div className="flex items-center justify-center">
          <Link
            to={layoutContent.data.cta.url}
            className="mt-8 flex max-w-xl items-center justify-center rounded-md bg-indigo-600 px-8 py-4 text-2xl font-semibold text-indigo-50 shadow-sm hover:bg-indigo-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
          >
            <div>{layoutContent.data.cta.title}</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

const Item = ({
  number,
  title,
  description,
}: {
  number: number;
  title: string;
  description: string;
}) => (
  <div className="grid max-w-4xl grid-cols-[42px_1fr] xl:grid-cols-[100px_1fr]">
    <div>
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 bg-indigo-600 p-3 text-2xl font-bold italic text-white xl:h-20 xl:w-20 xl:text-4xl">
        <div>{number}</div>
      </div>
    </div>
    <div className="flex flex-col gap-y-1">
      <h2 className="text-xl font-semibold xl:text-3xl">{title}</h2>
      <span className="text-md xl:text-xl">{description}</span>
    </div>
  </div>
);
